module.exports = __webpack_public_path__ + "img/CancerThumbnail.ce09370c.png";